<template>
  <div class="welcome-set-success">
    <img
      src="@/assets/images/newOrder/welcome-set-success.svg"
      alt=""
      class="welcome-set-success__img"
    >

    <h4 class="welcome-set-success__title">
      Заявка отправлена
    </h4>
    <p class="welcome-set-success__description">
      Оператор свяжется с вами<br>в ближайшее время
    </p>
    <CoreButton
      w100
      class-name="welcome-set-success__btn"
      @click="goToDashboard"
    >
      Хорошо
    </CoreButton>
  </div>
</template>

<script>
import CoreButton from '@/components/core/ui/CoreButton'

export default {
  name: 'WelcomeSetSuccessPage',

  components: {
    CoreButton,
  },

  methods: {
    goToDashboard () {
      this.$router.push('/')
    },
  },
}
</script>

<style lang="scss">
.welcome-set-success {
  position: fixed;
  padding: 24px;
  display: flex;
  flex-direction: column;
  color: map-get($colors, 'black');
  height: 100%;
  width: 100%;
  align-items: center;
  justify-content: center;

  &__img {
    width: 200px;
    margin-bottom: 40px;
    margin-top: auto;
  }

  &__title {
    font-size: 20px;
    font-weight: 600;
    line-height: 24px;
    letter-spacing: 0;
    text-align: center;
    margin-bottom: 8px;
  }

  &__description {
    font-size: 16px;
    line-height: 24px;
    letter-spacing: 0;
    text-align: center;
  }

  &__btn {
    max-height: 44px;
    min-height: 44px;
    border-radius: 14px;
    font-size: 14px;
    line-height: 20px;
    letter-spacing: 1px;
    padding: 12px 0;
    margin-top: auto;
  }
}
</style>
